import { render, staticRenderFns } from "./FeedPlan.vue?vue&type=template&id=5d716807"
import script from "./FeedPlan.vue?vue&type=script&lang=ts"
export * from "./FeedPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports